import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Http from './http'
import Filters from './filters.js'
import VueTour from 'vue-tour'
import './icons'
import svgIcon from './components/SvgIcon'
import './styles.js'
import '@fortawesome/fontawesome-svg-core'
import AsyncComputed from 'vue-async-computed'
import VModal from 'vue-js-modal'
import VueUploadComponent from 'vue-upload-component'
import '@/angularBridge/ngVueDirectives'
import VueEditor from 'vue2-editor'
import '../sass/main.scss'
import '../legacySass/main.scss'
import VueClipboard from 'vue-clipboard2'
import VueMoment from 'vue-moment'
import YesNoSwitch from './components/YesNoSwitch'
import money from 'v-money'
import ToggleButton from 'vue-js-toggle-button'
import Logger from '@/utility/Logger'

VueClipboard.config.autoSetContainer = true

require('vue-tour/dist/vue-tour.css')

Vue.component('file-upload', VueUploadComponent)

Vue.component('SvgIcon', svgIcon)

Vue.component('yes-no-switch', YesNoSwitch)

Vue.use(AsyncComputed)
Vue.use(Http, { store })
Vue.use(Logger, { store })
Vue.use(Filters)
Vue.use(VueTour)
Vue.use(VModal, { dialog: true, dynamic: true, dynamicDefaults: { clickToClose: false } })
Vue.use(VueClipboard)
Vue.use(VueEditor)
Vue.use(VueMoment)
Vue.use(ToggleButton)
Vue.use(YesNoSwitch)
Vue.use(money, { precision: 2 })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Vue.config.devtools = true
